import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll cả window (nếu cần)
    window.scrollTo({ top: 0, behavior: "smooth" })

    // Scroll Content layout
    const content = document.querySelector(".ant-layout-content")
    if (content) {
      content.scrollTo({ top: 0, behavior: "smooth" })
    }
  }, [pathname])

  return null
}

export default ScrollToTop
